var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 21.1287H12.25C8.5 21.1287 7 19.7045 7 16.144V11.8714C7 8.31092 8.5 6.88672 12.25 6.88672H16.75C20.5 6.88672 22 8.31092 22 11.8714V16.144C22 19.7045 20.5 21.1287 16.75 21.1287Z",
    fill: "#017EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.2111C3.16 10.2111 3.5 9.88828 3.5 9.499C3.5 6.68858 5.56 4.3339 8.33 3.71674L8.06 4.144C7.85 4.48581 7.96 4.92257 8.32 5.12195C8.68 5.32134 9.14 5.2169 9.35 4.87509L10.4 3.21352C10.54 2.99515 10.54 2.7198 10.41 2.50142C10.27 2.28305 10.02 2.14062 9.75 2.14062C5.48 2.14062 2 5.44477 2 9.499C2 9.88828 2.34 10.2111 2.75 10.2111Z",
    fill: "#017EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSteps);
export default __webpack_public_path__ + "static/media/nextSteps.87ffd2e9f071ddfc155dc3a6ef4e9df0.svg";
export { ForwardRef as ReactComponent };